import { createRootRoute } from "@tanstack/react-router";

import { RootLayout, RouteError } from "./-__root-layout";

export const Route = createRootRoute({
	component: RootLayout,
	errorComponent: RouteError,
});
